// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListAEu_TheComp__aNA7b","identifier":"ListAEu_identifier__T5o0k"};